<template>
  <div
    class="border-static-default-mid rounded-md relative w-full border p-16 text-center"
  >
    <RevIllustration
      alt=""
      :height="64"
      image-class-names="mx-auto"
      sizes="64px"
      :src="imageSrc"
      :width="64"
    />
    <span class="text-static-default-hi body-2-bold mt-12 line-clamp-1">{{
      title
    }}</span>
    <RevButtonIcon
      class="absolute right-0 top-0 p-8"
      :icon="IconCrossInCircleFilled"
      size="medium"
      variant="ghost"
      @click="emit('remove')"
    />
  </div>
</template>

<script setup lang="ts">
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { RevIllustration } from '@ds/components/Illustration'
import { IconCrossInCircleFilled } from '@ds/icons/IconCrossInCircleFilled'

const emit = defineEmits(['remove'])

defineProps<{ imageSrc: string; title: string }>()
</script>
